module.exports = __webpack_public_path__ + "static/media/spaces.e8260f0a.svg";